import { View } from 'react-native'
import Page from '@shell/Page'
import Typography from '@ui/typography'
import Button from '@ui/buttons/Button'
import { useToast } from '@ui/toasts/useToastManager'

export default function DevToastsPage() {
  const toast = useToast()

  return (
    <Page stage="dev">
      <View className="flex gap-8 p-16">
        <View className="gap-4">
          <Typography variant="LG">Toasts</Typography>
          <Typography variant="SM" className="color-desc">
            Trigger toasts of different types to test appearance and behaviour
            (e.g. on web, check that the dev UI does not unmount).
          </Typography>
        </View>

        <View className="gap-4">
          <Button
            label="Show Info Toast"
            onPress={() =>
              toast({
                variant: 'info',
                title: 'Info',
                text: 'This is an info message.',
              })
            }
          />
          <Button
            label="Show Success Toast"
            onPress={() =>
              toast({
                variant: 'success',
                title: 'Success',
                text: 'Operation completed successfully.',
              })
            }
          />
          <Button
            label="Show Warning Toast"
            onPress={() =>
              toast({
                variant: 'warning',
                title: 'Warning',
                text: 'Please review before continuing.',
              })
            }
          />
          <Button
            label="Show Error Toast"
            onPress={() =>
              toast({
                variant: 'error',
                title: 'Error',
                text: 'Something went wrong. Check the details and try again.',
              })
            }
          />
        </View>
      </View>
    </Page>
  )
}
